import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const ProgressSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`

export const ProgressDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
`

export const ProgressLabel = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  flex: 1;
`

export const InProgressPill = styled.span`
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: #4338ca;
  background: #eef2ff;
`

export const ProgressBarTrack = styled.div`
  position: relative;
  height: 10px;
  border-radius: 999px;
  background: #e5e7eb;
  margin-bottom: 8px;
`

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: #22c55e;
  width: ${({ percent }) => percent}%;
  transition: width 0.3s ease;
`

export const ProgressTarget = styled.div`
  position: absolute;
  top: -4px;
  left: ${({ percent }) => percent}%;
  width: 2px;
  height: 18px;
  background: #6b7280;
`

export const ProgressTargetLabel = styled.div`
  text-align: right;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 32px;
`

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`

export const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  ${({ $breakDown }) => ($breakDown ? 'gap: 10px;' : 'gap: 8px;')}
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
`

export const StatLabel = styled.div`
  font-size: 16px;
  color: #111827;
  margin-bottom: 8px;
`

export const StatValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const StatValue = styled.div`
  font-size: 40px;
  font-weight: 700;
  color: #111827;
  line-height: 36px;
`

export const StatusDotLarge = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const ChecklistItem = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 16px;
  color: #444444;
`

export const CheckIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #22c55e;
  color: #ffffff;
  font-size: 10px;
  flex-shrink: 0;
`

export const ActionsDashboardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 8px;
`

export const ActionsCardWrapper = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ActionsCardTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #111827;
`

export const ActionsCardSubTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  margin-top: 12px;
  margin-bottom: 4px;
`

export const ActionItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ActionListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #111827;
`

